var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 3.167,
    y: 3.167,
    width: 31.667,
    height: 31.667,
    rx: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.766 23.045a1.583 1.583 0 012.635-1.757c1.832 2.748 3.993 4.045 6.599 4.045 2.606 0 4.767-1.297 6.6-4.045a1.583 1.583 0 112.634 1.757C25.844 26.63 22.728 28.5 19 28.5c-3.728 0-6.844-1.87-9.234-5.455z",
    fill: "#fff"
  })));
}

export default SvgHappy;